import React from "react";
import Header from "../../components/GlobalComponents/Header/Header";
import First from "../../components/MainPage/First/First";
import Second from "../../components/MainPage/Second/Second";
import Third from "../../components/MainPage/Third/Third";
import Fourth from "../../components/MainPage/Fourth/Fourth";
import Fifth from "../../components/MainPage/Fifth/Fifth";
import Sixth from "../../components/MainPage/Sixth/Sixth";
import Seventh from "../../components/MainPage/Seventh/Seventh";
import Eighth from "../../components/MainPage/Eighth/Eighth";
import Footer from "../../components/GlobalComponents/Footer/Footer";


const MainPage = () => {
  return (
    <div>
      <Header />
      <First />
      <Second />
      <Third />
      <Fourth />
      <Fifth />
      <Sixth />
      <Seventh />
      <Eighth />
      <Footer />
    </div>
  );
};

export default MainPage;
